// Default post-login / cold-nav landing for an account.
// Admins with no inbox yet → usage guide; otherwise → Settings → Inboxes.
// Agents keep Conversations (dashboard).
export const USAGE_GUIDE_LANDING_PATH = 'custom/usage-guide';
export const INBOXES_LANDING_PATH = 'settings/inboxes/list';
export const DASHBOARD_LANDING_PATH = 'dashboard';

export function defaultAccountLandingPath({ isAdministrator, inboxCount }) {
  if (!isAdministrator) return DASHBOARD_LANDING_PATH;
  if (Number(inboxCount) === 0) return USAGE_GUIDE_LANDING_PATH;
  return INBOXES_LANDING_PATH;
}

export async function resolveDefaultAccountLandingPath(
  store,
  { isAdministrator }
) {
  if (!isAdministrator) return DASHBOARD_LANDING_PATH;

  let inboxes = store.getters['inboxes/getInboxes'] || [];
  // Empty may mean "not loaded yet" or "no inboxes" — refresh only then.
  if (inboxes.length === 0) {
    await store.dispatch('inboxes/get');
    inboxes = store.getters['inboxes/getInboxes'] || [];
  }

  return defaultAccountLandingPath({
    isAdministrator,
    inboxCount: inboxes.length,
  });
}

export function isDashboardLandingRoute(path = '') {
  return /\/dashboard\/?$/.test(path) || path === DASHBOARD_LANDING_PATH;
}

// Login, hard reload, and account switch (location.href) have no from.name.
// Sidebar "所有会话" is an in-app push to home and must not be hijacked.
export function isAccountLandingNavigation(to, from) {
  if (!from?.name) return true;

  const fromAccount = from.params?.accountId;
  const toAccount = to?.params?.accountId;
  if (
    fromAccount != null &&
    toAccount != null &&
    String(fromAccount) !== String(toAccount)
  ) {
    return true;
  }

  return false;
}
